import Vue from "vue";
import Vuetify from "vuetify";
import App from "./App.vue";

Vue.use(Vuetify);

Vue.config.productionTip = false;

new Vue({
  vuetify: new Vuetify({
    theme: {
      dark: false,
      themes: {
        dark: {
          primary: '#6366F1',
          secondary: '#F59E0B',
          background: '#0F172A',
          surface: '#1E293B',
        },
        light: {
          primary: '#6366F1',
          secondary: '#F59E0B',
          background: '#F8FAFC',
          surface: '#FFFFFF',
        },
      },
    },
  }),
  render: (h) => h(App),
}).$mount("#app");
